/*
 * VH-106 — Recipe Tips & Recommendations renderer.
 *
 * Thin wrapper around react-markdown with the same subset used by
 * HelpContent (bold/italic, paragraphs, bullet + numbered lists). Renders
 * NOTHING when `tips` is null / whitespace, so the parent can render the
 * card+header conditionally without re-checking.
 */

import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

const markdownComponents = {
  p({ children }) {
    return (
      <p className="text-gray-800 my-2 leading-relaxed whitespace-pre-wrap">
        {children}
      </p>
    )
  },
  ul({ children }) {
    return (
      <ul className="list-disc list-inside my-2 space-y-1 text-gray-800">
        {children}
      </ul>
    )
  },
  ol({ children }) {
    return (
      <ol className="list-decimal list-inside my-2 space-y-1 text-gray-800">
        {children}
      </ol>
    )
  },
  strong({ children }) {
    return <strong className="font-semibold">{children}</strong>
  },
  em({ children }) {
    return <em className="italic">{children}</em>
  },
}

export default function RecipeTips({ tips, 'data-testid': testId }) {
  const text = (tips || '').trim()
  if (!text) return null
  return (
    <div className="text-sm" data-testid={testId}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
        {text}
      </ReactMarkdown>
    </div>
  )
}
